export var ArrowTypeEnum;
(function (ArrowTypeEnum) {
    ArrowTypeEnum[ArrowTypeEnum["normal"] = 0] = "normal";
    ArrowTypeEnum[ArrowTypeEnum["inv"] = 1] = "inv";
    ArrowTypeEnum[ArrowTypeEnum["dot"] = 2] = "dot";
    ArrowTypeEnum[ArrowTypeEnum["invdot"] = 3] = "invdot";
    ArrowTypeEnum[ArrowTypeEnum["odot"] = 4] = "odot";
    ArrowTypeEnum[ArrowTypeEnum["invodot"] = 5] = "invodot";
    ArrowTypeEnum[ArrowTypeEnum["none"] = 6] = "none";
    ArrowTypeEnum[ArrowTypeEnum["tee"] = 7] = "tee";
    ArrowTypeEnum[ArrowTypeEnum["empty"] = 8] = "empty";
    ArrowTypeEnum[ArrowTypeEnum["invempty"] = 9] = "invempty";
    ArrowTypeEnum[ArrowTypeEnum["diamond"] = 10] = "diamond";
    ArrowTypeEnum[ArrowTypeEnum["odiamond"] = 11] = "odiamond";
    ArrowTypeEnum[ArrowTypeEnum["ediamond"] = 12] = "ediamond";
    ArrowTypeEnum[ArrowTypeEnum["crow"] = 13] = "crow";
    ArrowTypeEnum[ArrowTypeEnum["box"] = 14] = "box";
    ArrowTypeEnum[ArrowTypeEnum["obox"] = 15] = "obox";
    ArrowTypeEnum[ArrowTypeEnum["open"] = 16] = "open";
    ArrowTypeEnum[ArrowTypeEnum["halfopen"] = 17] = "halfopen";
    ArrowTypeEnum[ArrowTypeEnum["vee"] = 18] = "vee";
})(ArrowTypeEnum || (ArrowTypeEnum = {}));
//# sourceMappingURL=arrowTypeEnum.js.map